export enum FilterType {
  Radio = 'radio',
  Dropdown = 'dropdown',
  Multiselect = 'multiselect',
  Input = 'input',
  Composed = 'composed',
  Date = 'date',
  Range = 'range',
  Checkbox = 'checkbox',
  Chips = 'chips',
  TreeSelect = 'treeselect',
  DateRange = 'daterange',
}

export interface FilterOption {
  label: string;
  value: any;
  description?: string;
  count?: number;
}

export interface BaseFilter {
  id: string;
  label: string;
  type: FilterType;
  icon?: string;
  tooltip?: string;
}

export interface CheckboxFilter extends BaseFilter {
  type: FilterType.Checkbox;
  options: FilterOption[];
}

export interface MultiselectFilter extends BaseFilter {
  type: FilterType.Multiselect;
  options: FilterOption[];
  maxSelection?: number;
}

export interface InputFilter extends BaseFilter {
  type: FilterType.Input;
  placeholder?: string;
}

export interface RangeFilter extends BaseFilter {
  type: FilterType.Range;
  min: number;
  max: number;
}

export interface ChipsFilter extends BaseFilter {
  type: FilterType.Chips;
  tooltip?: string;
}

export interface DropdownFilter extends BaseFilter {
  type: FilterType.Dropdown;
  options: FilterOption[];
}

export interface MultipleDropdownFilter extends BaseFilter {
  type: FilterType.Composed;
  dropdowns: (DropdownFilter | MultiselectFilter | TreeSelectFilter)[];
}

export interface TreeSelectNode {
  key: string;
  label: string;
  data?: any;
  children?: TreeSelectNode[];
  selectable?: boolean;
}

export interface TreeSelectFilter extends BaseFilter {
  type: FilterType.TreeSelect;
  options: TreeSelectNode[];
}

export interface DateRangeFilter extends BaseFilter {
  type: FilterType.DateRange;
  minDate?: string;
  maxDate?: string;
}

export interface AppliedFilter<T extends BaseFilter = BaseFilter> {
  filter: T;
  isApplied: boolean;
  value: any;
}

export interface SearchCriteria {
  pagination: {
    offset: number;
    limit: number;
  };
  filters: FilterCriteria;
}

export interface SearchCriteriaCursor {
  pagination: {
    cursor: string | null;
    limit: number;
  };
  filters: FilterCriteria;
}

export interface FilterCriteria {
  [key: string]: any;
}

export type FilterConfig =
  | CheckboxFilter
  | MultiselectFilter
  | RangeFilter
  | ChipsFilter
  | DropdownFilter
  | MultipleDropdownFilter
  | TreeSelectFilter
  | InputFilter
  | DateRangeFilter;
